import React, { useContext } from 'react'
import Section from '../../../UIcomponent/Section'
import Col from '../../../UIcomponent/Column'
import LocalContext from '../../../Context/LocalContetxt'
import './DashboardCredit.scss'
import StyledButton from '../../../UIcomponent/Button'
import { Title } from '../../../UIcomponent/Title'
const DashboardCredit = (props) => {
    const lang = useContext(LocalContext).lang
    const config = useContext(LocalContext).config
    const { credit } = props
    return (
        <Section
            lang={lang}
        >
            <Col
                className='c__DashboardCredit'
                xl={18} lg={18} md={18} xs={24} sm={24}

            >
                {
                    <Col
                        xl={24} lg={24} md={24} xs={24} sm={24}
                        className='c__DashboardCredit__Credit'
                        style={{
                            flexDirection: config.role === 'Student' && 'row',
                            paddingBottom: config.role === 'Student' && '15px'
                        }}
                    >
                        {config.role === 'Teacher' &&
                            <Title
                                center
                            >
                                کیف پول
                            </Title>
                        }
                        <Col
                            xl={23} lg={23} md={23} xs={23} sm={23}
                            className='o__DashboardCredit__Credit'
                        >
                            {credit ? (credit / 10).toLocaleString(lang) : '0'} تومان
                        </Col>

                    </Col>
                }
                {config.role === 'Student' &&
                    <StyledButton
                        disable={true}
                        // width={'80%'}
                        secondary
                    >
                        افزایش اعتبار
                        </StyledButton>
                }
            </Col>
        </Section>
    )
}

export default DashboardCredit
